import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import commonUtil from '../../../../../utils/commonUtil';
import * as defaultConst from '../../../../../utils/clientConstant';
import { eventManagmentConfigWAP, OPENING_GIFT, CLOSING_GIFT } from './../../../eventManagementConfig';
import Tagging from '../../../../../components/Tagging/Tagging';

// const { eventManagmentConfigWAP, OPENING_GIFT, CLOSING_GIFT } = require('./../../../eventManagementConfig');

const applicationRoutes = commonUtil.getApplicationRoutes();

@connect(store => ({
  lables: store.labels.data,
  userEventDetails: store.eventDetails.userEventDetails,
  giftAvailable: store.eventDetails && store.eventDetails.userEventDetails ? store.eventDetails.userEventDetails.giftAvailable : null,
}))

class EventManagementIndex extends Component {
  constructor() {
    super();
    this.showOpeningGiftLink = true;
  }
  redirectToPage = (pageNameTemp, routeProps) => {
    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.eventManagement, { pageName: pageNameTemp, eventID: routeProps.eventID }));
  }

  closePresent = () => {
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'evTypeMesaAdd',
      selectOption: 'Regalo_por_cierre',
    });
  }

  render() {
    const EventDetails = this.props.userEventDetails;
    const eventCategory = EventDetails && EventDetails.eventDetailsInfo && EventDetails.eventDetailsInfo.eventType ? this.props.userEventDetails.eventDetailsInfo.eventCategory : null;
    const giftAvailable = this.props.giftAvailable;
    if (eventManagmentConfigWAP && eventManagmentConfigWAP.eventData) {
      Object.keys(eventManagmentConfigWAP.eventData).forEach((eventManagementPage) => {
        if (eventCategory === defaultConst.eventCategory.OPENEVENT && eventManagementPage !== OPENING_GIFT) {
          this.showOpeningGiftLink = false;
        } else if (eventCategory !== defaultConst.eventCategory.OPENEVENT && eventManagementPage !== CLOSING_GIFT) {
          this.showOpeningGiftLink = true;
        }
      });
    }
    const routeProps = this.props.params;
    return (
      <div className="row">
        <Tagging ref={tagging => this.tagging = tagging} />
        <div className="management-link" onClick={() => { this.redirectToPage('DatosDeMiEvento', routeProps); }}><a>Datos de mi evento <i className="icon-flecha_lightsvg_derecha" /></a> </div>
        <div className="management-link" onClick={() => { this.redirectToPage('DirecciónDeEntrega', routeProps); }}><a>Direcciones de entrega <i className="icon-flecha_lightsvg_derecha" /></a> </div>

        {this.showOpeningGiftLink && giftAvailable ?
          <div className="management-link" onClick={() => { this.redirectToPage('RegaloDeApertura', routeProps); this.closePresent(); }}><a>Regalo por apertura <i className="icon-flecha_lightsvg_derecha" /></a> </div>
          : null}
        {!this.showOpeningGiftLink && giftAvailable ?
          <div className="management-link" onClick={() => { this.redirectToPage('RegaloPorCierre', routeProps); }}><a>Regalo por cierre <i className="icon-flecha_lightsvg_derecha" /></a> </div>
          : null}
        <div className="management-link" onClick={() => { this.redirectToPage('TarjetaDeFestejado', routeProps); }}><a>Tarjeta de Festejado <i className="icon-flecha_lightsvg_derecha" /></a> </div>
        <div className="management-link" onClick={() => { this.redirectToPage('Contrato', routeProps); }}><a>Contrato <i className="icon-flecha_lightsvg_derecha" /></a> </div>
      </div>
    );
  }
}

export default EventManagementIndex;
